let $bbug = jQuery;

if (window.use_no_conflict) {
    $bbug = jQuery.noConflict(true);
}

angular
    .module('BB')
    .value('$bbug', $bbug);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_constants/bbug.js